import React, { Component } from 'react'
import './checkbutton.scss'

// Utils
import { translation } from '../../../utils/helpers'

class CheckButton extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }

    this.onClick = this.onClick.bind(this)
  }

  onClick (e) {
    // console.log('CheckButton onClick triggered!', e)
    if (this.props.onClick !== null) {
      this.props.onClick(e)
    }
  }

  getSizeClass () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 'l':
        return ' size-large'
      case 'm':
        return ' size-medium'
      case 's':
        return ' size-small'
    }
  }

  getStyle () {
    let css = '' + this.getSizeClass()

    if (this.props.checked) {
      css += ' checked'
    }

    return css
  }

  render () {
    let labelText = this.props.labelText
    if (typeof labelText === 'number') labelText = translation(labelText)

    return (
      <div className='element-check-button'>
        <button
          className={this.getStyle()}
          name={this.props.name}
          onClick={this.onClick}
        >
          {this.props.labelText && labelText}
          {this.props.children}
        </button>
      </div>
    )
  }
}

CheckButton.defaultProps = {
  size: 'm',
  labelText: null,
  onClick: null,
  name: null,
  checked: false
}

export default CheckButton



// WEBPACK FOOTER //
// ./src/app/shared/elements/checkButton/index.js